import React, { useState, useEffect } from "react";
import axios from "axios";
import { baseurl } from "../../../Baseurl";
import Swal from "sweetalert2";
import { Save } from "react-feather";
import AdminSidebar from "../../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../../component/AdminComp/AdminTopbar";
import { useParams, useNavigate } from "react-router-dom";

const EditBrand = () => {
  const { id, brand_name } = useParams();  // Get id and brand_name from route parameters
  const navigate = useNavigate();
  
  const [formData, setFormData] = useState({
    brandName: brand_name,  // Set initial brand name
  });

  // Handle form submission for updating brand
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Data being sent:", {
      id,
      brandName: formData.brandName,
    });

    try {
      const response = await axios.put(`${baseurl}updateBrand`, {
        id,
        brandName: formData.brandName,
      });
      if (response.status === 200) {
        Swal.fire("Success", "Brand updated successfully", "success");
        navigate(-1);  // Go back after successful update
      }
    } catch (error) {
      console.error("Error updating brand:", error);
      Swal.fire("Error", "There was an error updating the brand", "error");
    }
  };

  return (
    <>
      <div className="App" style={{ display: "flex" }}>
        <AdminSidebar />
        <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
          <AdminTopbar />
          <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h4 className="text-start">Edit Brand</h4>
            </div>

            <div className="text-start">
              <div className="row p-2">
                <div className="col-md-6 bg-white ">
                  <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                      <label className="form-label">Brand Name</label>
                      <input
                        type="text"
                        className="form-control"
                        value={formData.brandName}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            brandName: e.target.value,
                          })
                        }
                        required
                      />
                    </div>
                    <div className="mb-3 text-end">
                      <button type="submit" className="btn btn-primary">
                        <Save size={15} /> &nbsp; Save Changes
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditBrand;
